// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

//COMPONENT

class ColorSquare extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            color: '',
            isSelected: false,
        };

        this.selected = this.selected.bind(this);
    }

    componentDidMount(){
        this.setState({color: this.props.color});
    }

    componentDidUpdate(prevProps){
        if(this.props.color != prevProps.color){
            this.setState({color: this.props.color});
        }

        if(this.props.isSelected != prevProps.isSelected){
            this.setState({isSelected: this.props.isSelected});
        }
    }

    render() {
        return (
            <div className={'color-square ' + (this.state.isSelected ? 'selected-color' : '')} style={{background: this.state.color}} onClick={this.selected}/>
        );
    }

    selected(){
        this.props.colorSelected(this.state.color);
    }
}

ColorSquare.propTypes = {
    color: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    colorSelected: PropTypes.func.isRequired,
};

const hoc = withRouter(ColorSquare);

// EXPORT COMPONENT
export { hoc as ColorSquare };


// WEBPACK FOOTER //
// ./src/components/containers/ColorSquare.js